import { render } from "./WalletInstrumentTypeSummaryCard.vue?vue&type=template&id=e5779b94&scoped=true"
import script from "./WalletInstrumentTypeSummaryCard.vue?vue&type=script&lang=js"
export * from "./WalletInstrumentTypeSummaryCard.vue?vue&type=script&lang=js"

import "./WalletInstrumentTypeSummaryCard.vue?vue&type=style&index=0&id=e5779b94&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5779b94"]])

export default __exports__